import { v4 as uuidv4 } from "uuid";
import isNullish from "../common/helpers/isNullish";

class SpliceAiEvent {
  constructor(data) {
    const posStr = data?.splice_junction_coordinates || "";
    const pos = posStr ? SpliceAiEvent.parsePosition(posStr) : null;
    const mif = data?.missplicing_inframe;
    const mifStr = mif ? "Yes" : "No";
    const eventClass = data?.splicing_event_class;
    const skippedExons = data?.skipped_exons_id;
    const crypticDist = data?.cryptic_distance;
    const gtexSampleCount = data?.gtex_sample_count;
    const maxUniqReads = data?.gtex_max_uniq_map_reads;
    const sampleNo19 = data?.intropolis_sample_count;
    const sampleNo38 = data?.sra_sample_count;

    this.id = uuidv4();
    this.eventClass = isNullish(eventClass) ? null : String(eventClass);
    this.skippedExonsId = isNullish(skippedExons) ? null : String(skippedExons);
    this.crypticDistance = isNullish(crypticDist) ? null : crypticDist;
    this.missplicingInFrame = isNullish(mif) ? null : mifStr;
    this.gtexSampleCount = isNullish(gtexSampleCount) ? null : gtexSampleCount;
    this.gtexMaxUniqMapReads = isNullish(maxUniqReads) ? null : maxUniqReads;
    this.sampleCountHg19 = isNullish(sampleNo19) ? null : sampleNo19;
    this.sampleCountHg38 = isNullish(sampleNo38) ? null : sampleNo38;

    this.chr = pos?.chr ?? null;
    this.x0 = pos?.x0 ?? null;
    this.x1 = pos?.x1 ?? null;
  }

  static parsePosition(position = "") {
    if (typeof position !== "string" || !/^[\w]+:\d+-\d+$/.test(position)) {
      return null;
    }
    const [chr, pos] = position.split(":");
    const [x0, x1] = pos.split("-").map(Number);
    return Number.isNaN(x0) || Number.isNaN(x1) ? null : { chr, x0, x1 };
  }
}

export default SpliceAiEvent;
